module.exports = __webpack_public_path__ + "img/badge-expertise-silver-darkbg.ccc31e78.svg";